import { TaxAccountingOnboardingWizardTask } from './components/TaxAccountingOnboardingWizardTask';
import { TaOnboardingTasks } from './ta-onboarding';

export const TA_ONBOARDING_COMPONENT_MAP = {
  [TaOnboardingTasks.PROFILE_ONBOARDING_WIZARD]:
    TaxAccountingOnboardingWizardTask,
};
